import { RowClassParams } from 'ag-grid-community';

import { BomLineType, BomPartType } from 'bom/enums';
import { QuotePartRecordType } from 'quotes/enums';
import { IQuotePart } from 'quotes/types';

export const getManufacturerCellValue = (quotePart?: IQuotePart) => {
  if (!quotePart) {
    return;
  }

  if (BomPartType.DISCOUNT === quotePart.type) {
    return QuotePartRecordType.PRICING_GROUP_DISCOUNT === quotePart.recordType
      ? quotePart?.pricingGroupManufacturerName
      : quotePart?.partDiscountManufacturerName;
  }

  if (BomPartType.COMPONENT === quotePart.type) {
    return quotePart.manufacturerName;
  }

  return quotePart.partArr?.manufacturerName;
};

export const getLineCellValue = (quotePart?: IQuotePart) => {
  if (!quotePart) {
    return null;
  }

  if (quotePart.deleted) {
    return null;
  }

  if (quotePart.secondaryLine) {
    return Number(`${quotePart.line}.${quotePart.secondaryLine}`);
  }

  return quotePart.line;
};

export const getLineCellClass = (quotePart?: IQuotePart, hasRowReordering = true) => {
  const classes = ['overflowVisible', 'noDecorationCell'];

  if (hasRowReordering) {
    classes.push('paddingSmall');
  }

  if (!quotePart || quotePart.deleted) {
    return classes.join(' ');
  }

  if (quotePart.substituted) {
    classes.push('primaryRowCell');
  }

  if (quotePart.secondaryLine) {
    classes.push('secondaryRowCell');
  }

  return classes.join(' ');
};

export const getLineTypeCellValue = (quotePart?: IQuotePart) => {
  if (!quotePart) {
    return null;
  }

  if (quotePart.corporatePartConfig?.isBaseCodePart) {
    return BomLineType.BASE_CODE;
  }

  if (BomPartType.DISCOUNT === quotePart.type) {
    return BomLineType.DISCOUNT_CODE;
  }

  if (quotePart.partArr?.wildcard) {
    return BomLineType.WILDCARD;
  }

  if (quotePart.partArr?.baseIdentifier) {
    return BomLineType.CONFIGURED;
  }

  if (1 === +quotePart.partArr?.verified) {
    return BomLineType.VERIFIED;
  }

  return BomLineType.UNVERIFIED;
};

type TOpenLineRowClassRules = Record<
  'openLineRow',
  (params: RowClassParams<IQuotePart>) => boolean
>;

// rowClassRules, not getRowClass: AG-Grid never removes a class getRowClass stopped returning.
export const getOpenLineRowClassRules = (
  openLineId: IQuotePart['id'] | null
): TOpenLineRowClassRules => ({
  openLineRow: ({ data }) => null !== openLineId && String(data?.id) === String(openLineId),
});
